import history from 'utils/History/history';
import jwt_decode from 'jwt-decode';

import { NOT_AUTHENTICATED_HOME } from 'routes/routesConstants';

import store from "store/store";
import { showWarningMessage } from "reducers/application/applicationActions";

import { ACCESS_TOKEN_STORAGE, EXPIRES_AT_STORAGE, USERNAME_STORAGE, USER_STORAGE } from 'constants/storageConst';

export default class Auth {
    constructor() {
    }

    setAuthData(payload) {
        this.setJWT(payload.token);
        this.setUser(payload.user);
    }

    setJWT(accessToken) {
        var jwtDecoded = jwt_decode(accessToken);
        localStorage.setItem(ACCESS_TOKEN_STORAGE, accessToken);

        let expiresAt = JSON.stringify(jwtDecoded.exp);
        localStorage.setItem(EXPIRES_AT_STORAGE, expiresAt);

        localStorage.setItem(USERNAME_STORAGE, jwtDecoded.sub);
    }

    setUser(user) {
        localStorage.setItem(USER_STORAGE, JSON.stringify(user));
    }

    getUser() {
        const user = localStorage.getItem(USER_STORAGE);
        if (user) {
            return JSON.parse(user);
        } else {
            return {
                id: "",
                name: "",
                photoUrl: "",
                username: "",
                company: {}
            };
        }
    }

    cleanSession() {
        localStorage.removeItem(ACCESS_TOKEN_STORAGE);
        localStorage.removeItem(EXPIRES_AT_STORAGE);
        localStorage.removeItem(USERNAME_STORAGE);
        localStorage.removeItem(USER_STORAGE);
    }

    logout() {
        this.cleanSession();
        history.push(NOT_AUTHENTICATED_HOME);
    }

    logoutWithoutRedirection() {
        this.cleanSession();
    }

    isAuthenticated() {
        if (localStorage.getItem(ACCESS_TOKEN_STORAGE) && localStorage.getItem(EXPIRES_AT_STORAGE)) {
            let expiresAt = localStorage.getItem(EXPIRES_AT_STORAGE);
            let now = Math.round(new Date().getTime() / 1000);
            console.log("now: " + now + " expiresAt: " + expiresAt);
            let res = now < expiresAt;
            if (res == false) {
                store.dispatch(showWarningMessage("Sesión Expirada."));
            }
            return res;
        } else {
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/Auth/Auth.js